import { serializeTokens } from './tokens';
import { SerializedFarmConfig } from './types';

const serializedTokens = serializeTokens();

const farms: SerializedFarmConfig[] = [
  {
    pid: 0,
    lpSymbol: 'WBESC-WBNB LP',
    lpAddresses: {
      97: '0x489769805809d4f5F5B0aF34D57E32Be73a8e7D0',
      56: '0x489769805809d4f5F5B0aF34D57E32Be73a8e7D0',
    },
    token: serializedTokens.WBESC,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 1,
    lpSymbol: 'MONEY-WBESC LP',
    lpAddresses: {
      97: '0x1c8fc4506930ed7a58187c8A9E77cB0309c349B8',
      56: '0x1c8fc4506930ed7a58187c8A9E77cB0309c349B8',
    },
    token: serializedTokens.cake, // MONEY
    quoteToken: serializedTokens.WBESC,
  },
  {
    pid: 2,
    lpSymbol: 'BUSD-WBNB LP',
    lpAddresses: {
      97: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
      56: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
    },
    token: serializedTokens.busd,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 3,
    lpSymbol: 'WBESC-FUSD LP',
    lpAddresses: {
      97: '0xCaF66fBccc4C8D6d59611908A07CadbC31AC8721',
      56: '0xCaF66fBccc4C8D6d59611908A07CadbC31AC8721',
    },
    token: serializedTokens.WBESC,
    quoteToken: serializedTokens.fusd,
  },
  {
    pid: 4,
    lpSymbol: 'XRP-WBESC LP',
    lpAddresses: {
      97: '0x1897c037bC27982Fa3fA12413283bE66d08305EB',
      56: '0x1897c037bC27982Fa3fA12413283bE66d08305EB',
    },
    token: serializedTokens.xrp,
    quoteToken: serializedTokens.WBESC,
  },
  {
    pid: 5,
    lpSymbol: 'FUST-WBESC LP',
    lpAddresses: {
      97: '0x52D1974A9e19a3aaac7d9017BFc3e99BD57B8bfA',
      56: '0x52D1974A9e19a3aaac7d9017BFc3e99BD57B8bfA',
    },
    token: serializedTokens.fust,
    quoteToken: serializedTokens.WBESC,
  },
  {
    pid: 6,
    lpSymbol: 'FLOKI-WBESC LP',
    lpAddresses: {
      97: '0xB361bf96167633210d318Ee4dA3e1fd085725868', 
      56: '0xB361bf96167633210d318Ee4dA3e1fd085725868',
    },
    token: serializedTokens.floki,
    quoteToken: serializedTokens.WBESC,
  },
];

export default farms;
